/**
 * Spec 070 P6: the Manual pair list, built from `GET /quant/feed` `live_instruments` (echo-core 0.70.0).
 * `live_instruments === null` means the feed did not say (an older market process, or no answer): the
 * picker then keeps offering the instruments the Quant stack supports and makes no "no live feed" claim.
 * A list that is known but empty offers nothing.
 */
import type { FeedStatus, LiveSymbols, SymbolInfo } from './types'

const KNOWN: Record<string, Omit<SymbolInfo, 'symbol'>> = {
  NQ: { description: 'E-mini Nasdaq-100 futures', group: 'Futures', venue: 'CME', digits: 2 },
  GC: { description: 'Gold futures', group: 'Futures', venue: 'CME', digits: 1 },
}

/** Offered while the feed's instrument list is unknown. */
export const UNKNOWN_FEED_INSTRUMENTS: readonly string[] = ['NQ', 'GC']

function info(instrument: string): SymbolInfo {
  return { symbol: instrument, ...(KNOWN[instrument] ?? { description: instrument, group: 'Futures', venue: 'CME', digits: 2 }) }
}

export function symbolsFromFeed(feed: Pick<FeedStatus, 'state' | 'live_instruments'>): LiveSymbols {
  const list = feed.live_instruments
  const known = Array.isArray(list)
  const instruments = known ? list : UNKNOWN_FEED_INSTRUMENTS
  return { symbols: instruments.map(info), known, feedState: feed.state }
}
